import { defineNuxtPlugin } from "#app";
import { EventBus } from "~/composables/bus";

interface TooltipBinding {
  value: string;
  arg?: "top" | "bottom";
}

export default defineNuxtPlugin((nuxtApp: any) => {
  let touchTimer: NodeJS.Timeout;

  const showTooltip = (event: MouseEvent | TouchEvent, binding: TooltipBinding) => {
    if (!event) return;

    // @ts-ignore
    const rect = event?.target?.getBoundingClientRect();
    const position = binding.arg || "top";
    EventBus.$emit("show_tooltip", {
      text: binding.value,
      x: rect.left + rect.width / 2 + window.pageXOffset, // середина элемента
      y: position === "top" ? rect.top + window.pageYOffset : rect.bottom + window.pageYOffset,
      position
    });
  };

  const hideTooltip = () => {
    clearTimeout(touchTimer);
    EventBus.$emit("hide_tooltip");
  };

  // Helper uchun event handler-larni keyinroq remove qilish uchun reference qilib olamiz
  function onMouseEnter(e: MouseEvent, binding: TooltipBinding) {
    showTooltip(e, binding);
  }
  function onTouchStart(event: TouchEvent, binding: TooltipBinding) {
    touchTimer = setTimeout(() => showTooltip(event.touches[0], binding), 500);
  }

  nuxtApp.vueApp.directive("tooltip", {
    mounted(el: HTMLElement, binding: TooltipBinding) {
      // Event handlerlarni reference qilib qo'yamiz, remove qilish uchun kerak bo'ladi
      const mouseEnterHandler = (e: MouseEvent) => showTooltip(e, binding);
      const mouseLeaveHandler = hideTooltip;
      const touchStartHandler = (e: TouchEvent) => {
        touchTimer = setTimeout(() => showTooltip(e.touches[0], binding), 500);
      };
      const touchEndHandler = hideTooltip;
      const touchCancelHandler = hideTooltip;

      // Hammasini datasetga saqlab qo'yamiz
      // @ts-ignore
      el._tooltipHandlers = {
        mouseEnterHandler,
        mouseLeaveHandler,
        touchStartHandler,
        touchEndHandler,
        touchCancelHandler
      };

      el.addEventListener("mouseenter", mouseEnterHandler);
      el.addEventListener("mouseleave", mouseLeaveHandler);

      // touchstart ni passive qilib qo'shamiz
      el.addEventListener("touchstart", touchStartHandler, { passive: true });
      el.addEventListener("touchend", touchEndHandler, { passive: true });
      el.addEventListener("touchcancel", touchCancelHandler, { passive: true });
    },
    updated(el: HTMLElement, binding: TooltipBinding) {
      EventBus.$emit("update_tooltip_text", {
        text: binding.value
      });
    },
    unmounted(el: HTMLElement) {
      // @ts-ignore
      const handlers = el._tooltipHandlers;
      if (handlers) {
        el.removeEventListener("mouseenter", handlers.mouseEnterHandler);
        el.removeEventListener("mouseleave", handlers.mouseLeaveHandler);
        el.removeEventListener("touchstart", handlers.touchStartHandler, { passive: true });
        el.removeEventListener("touchend", handlers.touchEndHandler, { passive: true });
        el.removeEventListener("touchcancel", handlers.touchCancelHandler, { passive: true });
        // @ts-ignore
        delete el._tooltipHandlers;
      }
    }
  });
});
